import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

export default class Popover extends Component {
  static propTypes = {
    text: PropTypes.string,
    element: PropTypes.element,
    iconClass: PropTypes.string,
    icon: PropTypes.bool,
    triggerClass: PropTypes.string,
    popoverClass: PropTypes.string,
    hover: PropTypes.bool,
    onShow: PropTypes.func,
    onHide: PropTypes.func,
    content: PropTypes.string,
    visible: PropTypes.bool,
    onClickOutside: PropTypes.func,
    inPlace: PropTypes.bool,
    placement: PropTypes.string,
    invertedColors: PropTypes.bool,
    extraMarginTop: PropTypes.number,
  };

  static defaultProps = {
    icon: true,
    element: null,
    visible: false,
    iconClass: 'Icon Icon-info',
    onShow: () => {},
    onHide: () => {},
    onClickOutside: () => {},
    content: '',
    hover: false,
    inPlace: false,
    placement: undefined,
    invertedColors: false,
    extraMarginTop: 0,
  };

  constructor(props) {
    super(props);

    this.triggerRef = React.createRef();
    this.state = { open: false };
  }

  componentDidMount() {
    document.addEventListener('click', this.outsideClick);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.outsideClick);
  }

  outsideClick = (e) => {
    if (this.props.hover) {
      return;
    }
    if (!this.clickHandled) {
      this.hide();
    } else {
      this.clickHandled = false;
    }

    this.props.onClickOutside(e);
  };

  onClick = (e) => {
    if (this.props.hover) {
      return;
    }
    this.clickHandled = true;
    if (this.triggerRef.current == e.target) {
      this.show();
    }
  };

  hide() {
    if (this.state.open) {
      this.props.onHide();
    }
    this.setState({ open: false });
  }

  show() {
    if (!this.state.open) {
      this.props.onShow();
    }
    this.setState({ open: true });
  }

  onMouseEnter = (e) => {
    if (this.props.hover) {
      this.show();
    }
  };

  onMouseLeave = (e) => {
    if (this.props.hover) {
      this.hide();
    }
  };

  renderPopover() {
    const { bottom, left, right, top } = this.triggerRef.current.getBoundingClientRect();
    const tailwindConfig = require('../../../../tailwind.config');
    const isMobile = window.innerWidth < Number(tailwindConfig.theme.screens.lg.split('px')[0]);

    const classes = [
      'u-absolute u-z-200 u-rounded u-p-4 u-border u-mt-2 u-shadow-lg u-cursor-default tooltip',
    ];
    if (this.props.invertedColors) {
      classes.push('u-border-black u-bg-black u-text-white tooltip-black');
    } else {
      classes.push('u-border-grey-light u-bg-white u-text-black');
    }

    if (this.props.inPlace) {
      classes.push('tooltip--inplace');
    }
    if (!this.props.placement) {
      classes.push('tooltip--bottom-left');
    } else {
      classes.push(`tooltip--${this.props.placement}`);
    }
    classes.push(this.props.popoverClass);

    const style = {
      top: bottom + window.scrollY + this.props.extraMarginTop,
      left: isMobile ? 'auto' : left + window.scrollX - (this.props.hover ? 12 : 0),
      right: isMobile ? 16 : 'auto',
    };

    if (this.props.inPlace) {
      return (
        <div className={classes.join(' ')}>
          {this.props.children}
          {!this.props.children && <div dangerouslySetInnerHTML={{ __html: this.props.content }} />}
        </div>
      );
    } else {
      return ReactDOM.createPortal(
        <div className={classes.join(' ')} style={style}>
          {this.props.children}
          {!this.props.children && <div dangerouslySetInnerHTML={{ __html: this.props.content }} />}
        </div>,
        document.body
      );
    }
  }
  render() {
    const { icon, iconClass, text, triggerClass, element } = this.props;
    const handlers = {
      onMouseEnter: this.onMouseEnter,
      onMouseLeave: this.onMouseLeave,
      onClick: this.onClick,
    };

    const classes = [triggerClass, this.props.inPlace ? 'u-absolute u-inset-0' : ''].join(' ');
    return (
      <div
        {...handlers}
        ref={this.triggerRef}
        className={`${this.props.hover ? 'has-hover' : ''} ${classes}`}>
        {element}
        {text}
        {icon && <i className={`u-text-old-dark-grey ${text ? 'u-ml-2' : ''} ${iconClass}`}></i>}
        {(this.state.open || this.props.visible) && this.renderPopover()}
      </div>
    );
  }
}
